import React from 'react';

import { Container } from './styles';
import { CloseBlue } from '../../../../../../components/Icons/CloseBlue';

interface Props {
  fileName: string;
  fileSize: number;
  onClick: () => void;
}

export default function FileAttached({ fileName, fileSize, onClick }: Props): JSX.Element {
  const getSizeInMb = (size: number): string => {
    return (size / (1024 * 1024)).toFixed(2);
  };

  return (
    <Container htmlFor="test">
      <div>
        <img src="" alt="" />
        <span>{fileName}</span>
      </div>
      <div className="section">
        <span>{getSizeInMb(fileSize)} MB</span>
        <button className="btn-close" onClick={onClick}>
          <CloseBlue />
        </button>
      </div>
    </Container>
  );
}
